import networkTS from '@/misc/apis/networkTS'
import {
  SchedulerAppointmentSlotInput,
  SchedulerCancelAppointmentsResponse,
  SchedulerCancelRegistrationResponse,
  SchedulerCreateAppointmentsResponse,
  SchedulerCreateTokenForRequestingAppointmentsResponse,
  SchedulerGetAvailableSlotsResponse,
  SchedulerGetRegistrationResponse,
  SchedulerGetReminderConfigResponse,
  SchedulerGetSenderMailboxResponse,
  SchedulerGetTokenForRegisteringResponse,
  SchedulerListAppointmentsByObjectIdResponse,
  SchedulerListAppointmentsByTokenResponse,
  SchedulerSetReminderConfigRequest,
  SchedulerSetReminderConfigResponse,
  SchedulerSetSenderMailboxRequest,
  SchedulerSetSenderMailboxResponse,
  SchedulerSubmitRequestedAppointmentsResponse,
  SchedulerSubmitSlotSelectionRequest,
  SchedulerSubmitSlotSelectionResponse,
  SchedulerUnregisterParticipantResponse,
  SchedulerUpdateMaxParticipantsResponse
} from '@/types/api'

export default {
  listAppointmentsByObjectId(objectId: string): Promise<SchedulerListAppointmentsByObjectIdResponse> {
    return networkTS.schedulerServiceListAppointmentsByObjectId({ objectId })
      .then(response => response.data)
  },
  createAppointments(objectId: string, slots: SchedulerAppointmentSlotInput[]): Promise<SchedulerCreateAppointmentsResponse> {
    return networkTS.schedulerServiceCreateAppointments({ objectId, slots })
      .then(response => response.data)
  },
  listAppointmentsByToken(token: string): Promise<SchedulerListAppointmentsByTokenResponse> {
    return networkTS.schedulerServiceListAppointmentsByToken(token)
      .then(response => response.data)
  },
  submitRequestedAppointments(token: string, slots: SchedulerAppointmentSlotInput[]): Promise<SchedulerSubmitRequestedAppointmentsResponse> {
    return networkTS.schedulerServiceSubmitRequestedAppointments({ token, slots })
      .then(response => response.data)
  },
  createTokenForRequestingAppointments(objectId: string, contactId: string): Promise<SchedulerCreateTokenForRequestingAppointmentsResponse> {
    return networkTS.schedulerServiceCreateTokenForRequestingAppointments({ objectId, contactId })
      .then(response => response.data)
  },
  getTokenForRegistering(objectId: string): Promise<SchedulerGetTokenForRegisteringResponse> {
    return networkTS.schedulerServiceGetTokenForRegistering(objectId)
      .then(response => response.data)
  },
  unregisterParticipant(appointmentId: string, participantId: string): Promise<SchedulerUnregisterParticipantResponse> {
    return networkTS.schedulerServiceUnregisterParticipant({ appointmentId, participantId })
      .then(response => response.data)
  },
  cancelAppointments(ids: string[]): Promise<SchedulerCancelAppointmentsResponse> {
    return networkTS.schedulerServiceCancelAppointments({ ids })
      .then(response => response.data)
  },
  getAvailableSlots(token: string): Promise<SchedulerGetAvailableSlotsResponse> {
    return networkTS.schedulerServiceGetAvailableSlots(token)
      .then(response => response.data)
  },
  getRegistration(token: string, participantId: string): Promise<SchedulerGetRegistrationResponse> {
    return networkTS.schedulerServiceGetRegistration(token, participantId)
      .then(response => response.data)
  },
  cancelRegistration(token: string, participantId: string): Promise<SchedulerCancelRegistrationResponse> {
    return networkTS.schedulerServiceCancelRegistration({ token, participantId })
      .then(response => response.data)
  },
  submitSlotSelection(payload: SchedulerSubmitSlotSelectionRequest): Promise<SchedulerSubmitSlotSelectionResponse> {
    return networkTS.schedulerServiceSubmitSlotSelection(payload)
      .then(response => response.data)
  },
  getReminderConfig(accountId: string): Promise<SchedulerGetReminderConfigResponse> {
    return networkTS.schedulerServiceGetReminderConfig({ accountId })
      .then(response => response.data)
  },
  setReminderConfig(payload: SchedulerSetReminderConfigRequest): Promise<SchedulerSetReminderConfigResponse> {
    return networkTS.schedulerServiceSetReminderConfig(payload)
      .then(response => response.data)
  },
  getSenderMailbox(accountId: string): Promise<SchedulerGetSenderMailboxResponse> {
    return networkTS.schedulerServiceGetSenderMailbox({ accountId })
      .then(response => response.data)
  },
  setSenderMailbox(payload: SchedulerSetSenderMailboxRequest): Promise<SchedulerSetSenderMailboxResponse> {
    return networkTS.schedulerServiceSetSenderMailbox(payload)
      .then(response => response.data)
  },
  updateMaxParticipants(appointmentId: string, maxParticipants?: number): Promise<SchedulerUpdateMaxParticipantsResponse> {
    return networkTS.schedulerServiceUpdateMaxParticipants({ appointmentId, maxParticipants })
      .then(response => response.data)
  }
}
